import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAllRecurring, pauseRecurring, resumeRecurring } from "./RecurringService";
import "./RecurringList.css";


export default function RecurringList(){
const [items,setItems] = useState([]);
const nav = useNavigate();


useEffect(()=>{ load(); },[]);


const load = async ()=>{
const data = await getAllRecurring();
setItems(data);
};


return (
<div className="recurring-list-wrap">
<h2>Recurring Payments</h2>


<button className="btn btn-primary recurring-list-add-btn" onClick={()=>nav("new")}>➕ Add Recurring</button>


<div className="recurring-list-grid">
{items.map(r=> (
<div key={r.id} className="recurring-list-card">
<div className="recurring-list-title">{r.title}</div>
<div>{r.type}</div>
<div>₹ {r.amount}</div>
<div>{r.frequency}</div>
<div>Next: {r.nextRunDate}</div>


<div className="recurring-list-actions">
{r.active
? <button className="btn" onClick={async()=>{ await pauseRecurring(r.id); load(); }}>⏸ Pause</button>
: <button className="btn btn-primary" onClick={async()=>{ await resumeRecurring(r.id); load(); }}>▶ Resume</button>
}
</div>
</div>
))}
</div>
</div>
);
}
